"use strict";

/**
 * @generated SignedSource<<d239ad35ae6db2e1e75d21c121983efa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Landing_FmoHomeViewer",
  "selections": [{
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "avatarUrl",
    "storageKey": null
  }, {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  }, {
    "alias": null,
    "args": [{
      "kind": "Literal",
      "name": "first",
      "value": 25
    }],
    "concreteType": "FleetCompanyConnection",
    "kind": "LinkedField",
    "name": "fleetCompaniesAsManager",
    "plural": false,
    "selections": [{
      "alias": null,
      "args": null,
      "concreteType": "FleetCompanyEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [{
        "args": null,
        "kind": "FragmentSpread",
        "name": "ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies"
      }],
      "storageKey": null
    }],
    "storageKey": "fleetCompaniesAsManager(first:25)"
  }],
  "type": "User",
  "abstractKey": null
};
node.hash = "3f82534f0eb08c1238b41114f3a4e437";
export default node;